// Story tabs
document.querySelectorAll('[data-story-tabs]').forEach(function (wrap) {
  var tabs = wrap.querySelectorAll('.story__tab');
  var panels = wrap.closest('.story').querySelectorAll('.story__panel');
  tabs.forEach(function (tab, i) {
    tab.addEventListener('click', function () {
      tabs.forEach(function (t) { t.classList.remove('is-active'); });
      panels.forEach(function (p) { p.classList.remove('is-active'); });
      tab.classList.add('is-active');
      if (panels[i]) panels[i].classList.add('is-active');
    });
  });
});

// PDP offer selection
document.querySelectorAll('[data-offer-box]').forEach(function (box) {
  var offers = box.querySelectorAll('.offer');
  var form = box.closest('form');
  // Sync hidden variant id with the preselected offer on load
  var preselected = box.querySelector('.offer.is-selected');
  if (form && preselected && preselected.dataset.variantId) {
    var idField0 = form.querySelector('input[name="id"]');
    if (idField0) idField0.value = preselected.dataset.variantId;
  }
  offers.forEach(function (offer) {
    offer.addEventListener('click', function () {
      offers.forEach(function (o) { o.classList.remove('is-selected'); });
      offer.classList.add('is-selected');
      var input = offer.querySelector('input[type="radio"]');
      if (input) input.checked = true;
      if (form) {
        var idField = form.querySelector('input[name="id"]');
        if (idField && offer.dataset.variantId) idField.value = offer.dataset.variantId;
        var sellingPlan = form.querySelector('input[name="selling_plan"]');
        if (sellingPlan) sellingPlan.value = offer.dataset.sellingPlan || '';
      }
    });
  });
});

// PDP gallery
document.querySelectorAll('[data-gallery]').forEach(function (g) {
  var main = g.querySelector('.pdp__main-img img');
  g.querySelectorAll('.pdp__thumbs img').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      if (main) main.src = thumb.dataset.full || thumb.src;
      g.querySelectorAll('.pdp__thumbs img').forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
    });
  });
});

// PDP sticky add-to-cart (mobile)
(function () {
  var sticky = document.querySelector('[data-sticky-atc]');
  if (!sticky) return;
  var form = document.querySelector('.pdp form[action*="/cart/add"]') || document.querySelector('.pdp form');
  var mainBtn = form && form.querySelector('button[name="add"]');
  var priceEl = sticky.querySelector('[data-sticky-price]');
  if (!form || !mainBtn) return;
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { sticky.setAttribute('hidden', ''); }
      else if (e.boundingClientRect.top < 0) { sticky.removeAttribute('hidden'); }
    });
  }, { threshold: 0 });
  io.observe(mainBtn);
  sticky.querySelector('[data-sticky-add]').addEventListener('click', function () {
    var offers = document.querySelector('[data-offer-box]');
    var dest = offers || mainBtn;
    dest.scrollIntoView({ behavior: 'smooth', block: 'center' });
    dest.classList.remove('is-pulse'); void dest.offsetWidth;
    setTimeout(function () { dest.classList.add('is-pulse'); }, 450);
  });
  // keep sticky price in sync with selected offer
  document.querySelectorAll('[data-offer-box] .offer').forEach(function (offer) {
    offer.addEventListener('click', function () {
      var priceNode = offer.querySelector('.offer__head span:last-child');
      if (priceEl && priceNode) {
        var txt = priceNode.textContent.replace(/\s+/g, ' ').trim();
        var m = txt.match(/[£$€][\d.,]+(?!.*[£$€])/);
        if (m) priceEl.textContent = m[0];
      }
    });
  });
})();
